import { Chakra } from "@airhelp/react-ui-components";

const { createIcon } = Chakra;

const SupChatIcon = createIcon({
  displayName: "stickyBottomBarAhPlusLogo",
  viewBox: "0 0 60 60",
  path: (
    <svg>
      <g fill="none" fillRule="evenodd">
        <circle cx="30" cy="29.8" r="30" fill="#1B8EFF" />
        <g fill="#FFF" fillRule="nonzero">
          <path d="M43.571 22.2h-3.428v6.62c0 3.656-3.07 6.62-6.857 6.62H23v1.655c0 1.82 1.543 3.31 3.429 3.31h15.428l3.679 3.55c.54.522 1.464.153 1.464-.583V25.51c0-1.82-1.543-3.31-3.429-3.31z" />
          <path d="M33.571 14.2H16.43C14.543 14.2 13 15.69 13 17.51v17.86c0 .737.924 1.108 1.464.586l3.679-3.553H33.57c1.886 0 3.429-1.489 3.429-3.31V17.51c0-1.82-1.543-3.31-3.429-3.31z" />
        </g>
      </g>
    </svg>
  ),
});

export { SupChatIcon };
